import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";


let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:
import * as blazeSlider from './scripts/slider';
blazeSlider.init();

import * as dynamicTabbing from './scripts/dynamic-tabbing';
dynamicTabbing.init();

import * as casaForm from './scripts/casa-form';
casaForm.init();

import Tab from 'bootstrap/js/dist/tab';
onFind('[data-bs-toggle="tab"]',function (element) {
    new Tab(element);
});

import * as formValidation from '@elements/form-validation';
formValidation.init({
    trigger:{event: 'false'}
});

import * as smoothScroll from '@elements/smooth-scroll';
smoothScroll.init({
    scrollOffset: 230,
    initialPosition: true
});

import * as anchorNav from '@elements/anchor-nav/bootstrap-5.js';
anchorNav.init({
        renderItem: function (text, anchor) {
            return '<li class="nav-item anchor-nav__item js-anchor-nav__list-item list-inline-item"><a class="nav-link js-scroll-spy__link js-anchor-nav__link js-anchor-nav__item anchor-nav__link js-smoothscroll__link" data-scroll-offset="160" href="#' + anchor + '"><span class="anchor-nav__title">' + text + '</span></a></li>';
        },
        smoothScroll: true,
        scrollSpy: true,
        scrollSpyOffset: 500
    },
    {
        list: '.js-anchor-nav__list',
        item: '.js-anchor-nav__item'
    }
);


import * as affix from '@elements/affix';
affix.init({
    offset: 113,
    breakpoints: {
        0: {
            offset: 110
        },
        768: {
            offset: 93
        },
        1200: {
            offset: 113
        }
    }
});

import * as anchorNavExtension from './scripts/anchor-nav-extension';
anchorNavExtension.init();

import * as anchorNavScroll from "./scripts/anchor-nav-scroll.js";
anchorNavScroll.init(window.scope);